export const rowsPerPageOptions: number[] = [10, 25, 50]
export const rowsOnSearch = 50
